export const DEBOUNCE_CONFIG = {
  delay: {
    updateRequest: 800,
    longUpdateRequest: 5000,
  },
}
